export default __webpack_public_path__ + "static/media/OUR-GOALS.eed84f21.png";